export function fromRequest(data, schema) {
    return Object.assign(schema, {}, data.attributes, {
        id: parseInt(data.id),
    });
}

export function getPaginationMeta(data) {
    if (data.meta.pagination !== "undefined") {
        return data.meta.pagination;
    }

    return null;
}
